import moment from 'moment';
import { ParamterNames } from '../../models/report.model';

const dataLayer = window.dataLayer || [];

const gtmEvents = {
  analyticsScheduleReport: 'analyticsScheduleReport',
};

export default function JobCreateController(
  $scope,
  $rootScope,
  $uibModal,
  $uibModalInstance,
  JobSchedulerService,
  $state,
  $filter,
  securityGroupsService,
  usersService,
  scheduleAttributes,
  gettextCatalog,
) {
  'ngInject';

  //defualt onei3 schedule report tag
  $scope.tag = 'onei3:schedule:report';
  $scope.scheduleName = scheduleAttributes.reportName;
  scheduleAttributes.dateRange = scheduleAttributes.dateRange ? scheduleAttributes.dateRange : {};
  scheduleAttributes.selectedAssets = scheduleAttributes.selectedAssets
    ? scheduleAttributes.selectedAssets
    : [];
  $scope.firstCall = false;
  $scope.user = usersService.currentUser();
  $scope.disableModalWindow = false;
  $scope.selectedAssets = [];
  //reportPath has to be passed from the parent controller
  $scope.reportPath = scheduleAttributes.reportPath;

  $scope.$on('totalEmails', function (event, totalEmails) {
    $scope.maxEmails = totalEmails.length;
  });

  ///Dates, short forms 7d = 7 Days, MTD = Month to date
  $scope.dropDownDates = [
    {
      id: 1,
      label: gettextCatalog.getString('7d'),
      reportName: gettextCatalog.getString('Last 7 Days'),
      tooltip: gettextCatalog.getString('Last 7 Days'),
    },
    {
      id: 2,
      label: gettextCatalog.getString('MTD'),
      reportName: gettextCatalog.getString('Month-To-Date'),
      tooltip: gettextCatalog.getString('Month-To-Date'),
    },
    {
      id: 3,
      label: gettextCatalog.getString('30d'),
      reportName: gettextCatalog.getString('Last 30 Days'),
      tooltip: gettextCatalog.getString('Last 30 Days'),
    },
    {
      id: 4,
      label: gettextCatalog.getString('90d'),
      reportName: gettextCatalog.getString('Last 90 Days'),
      tooltip: gettextCatalog.getString('Last 90 Days'),
    },
  ];

  $scope.selectedDateRange = scheduleAttributes.dateRange
    ? $scope.dropDownDates[scheduleAttributes.dateRange.id - 1]
    : $scope.dropDownDates[0];

  const getPlantName = () => {
    return scheduleAttributes.reportParameters[ParamterNames.Plant]
      ? `- ${scheduleAttributes.reportParameters[ParamterNames.Plant]}`
      : '';
  };
  $scope.schedule = {
    jobName: scheduleAttributes.reportName
      ? `${scheduleAttributes.reportName} - ${
          scheduleAttributes.dateRange.reportDateName
        } ${getPlantName()}`
      : undefined,
    startDate: moment().toDate(),
    recurrence: 'Day',
    dateRange: $scope.selectedDateRange,
    selectedAssets: scheduleAttributes.selectedAssets,
    deliveryTime: undefined,
    actions: [],
    reportParameters: scheduleAttributes.reportParameters,
    enabled: true,
    contacts: [],
    create: true,
    reportPath: scheduleAttributes.reportPath,
    reportName: scheduleAttributes.reportName,
    reportDoesNotRequireAssets: scheduleAttributes.reportDoesNotRequireAssets,
  };

  $scope.numSelectedAssets =
    $scope.schedule.selectedAssets.length > 0 ? $scope.schedule.selectedAssets.length : undefined;

  $scope.openDatePickers = {};

  $scope.status = {
    isFirstOpen: false,
    isFirstDisabled: false,
  };

  //Local variables
  $scope.usersByPage = [];
  $scope.userData = [];
  $scope.filteredUserData = [];
  $scope.query = '';
  $scope.search = {
    text: '',
  };
  $scope.loading = false;

  //Pagination
  $scope.currentPage = {};
  $scope.bigCurrentPage = 1;
  $scope.itemsPerPage = 10;
  $scope.maxSize = 1;

  $scope.today = function () {
    $scope.dt = moment().toDate();
  };
  $scope.today();

  $scope.clear = function () {
    $scope.dt = null;
  };

  // Disable weekend selection
  $scope.disabled = function (date, mode) {
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
  };

  $scope.dateOptions = {
    formatYear: 'yy',
    startingDay: 1,
  };

  $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
  $scope.format = $scope.formats[3];

  $scope.status = {
    //opened: false
    isFirstOpen: false,
    isFirstDisabled: false,
  };

  let tomorrow = moment().toDate();
  tomorrow.setDate(tomorrow.getDate() + 1);
  let afterTomorrow = moment().toDate();
  afterTomorrow.setDate(tomorrow.getDate() + 2);
  $scope.events = [
    {
      date: tomorrow,
      status: 'full',
    },
    {
      date: afterTomorrow,
      status: 'partially',
    },
  ];

  $scope.emails = [];
  $scope.$on('disableDate', function (event, args) {
    $scope.date_checked = args.Calendar;
  });

  $scope.submitted = false;

  $scope.resourceUrl = securityGroupsService.getResourceUrl();
  $scope.animationsEnabled = true;
  $scope.existingEquips = [];
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.successFlag = false;

  $scope.equipments = []; //list of equipments to send to the database
  $scope.postRemoval = [];
  $scope.removeFlags = {};
  $scope.filteredEquipmentList = [];
  $scope.equipmentByPage = [];
  $scope.search = {
    text: '',
  };
  $scope.loading = true;

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;

  //Pagination
  $scope.current = {
    equipmentPage: 1,
    usersPage: 1,
  };
  $scope.itemsPerPage = 8;
  $scope.maxSize = 1;

  $scope.toggleAnimation = function () {
    $scope.animationsEnabled = !$scope.animationsEnabled;
  };

  let gatherDataNewReq = function (scheduleAttributes) {
    $scope.schedule = scheduleAttributes;
    $scope.schedule.startDate = moment($scope.schedule.startDate).toDate();
    $scope.schedule.startDate.setHours(
      $scope.schedule.deliveryTime.dateTime.getHours(),
      $scope.schedule.deliveryTime.dateTime.getMinutes(),
    );

    if ($scope.schedule.reportName.includes('Raw Asset Data')) {
      addCSVParams();
    }

    for (let key in $scope.schedule.reportParameters) {
      if ($scope.schedule.reportParameters.hasOwnProperty(key)) {
        switch ($scope.schedule.reportParameters[key]) {
          case 'AccountId':
            $scope.schedule.reportParameters[key] = $scope.user.account.id;
            break;
          case 'UserName':
            $scope.schedule.reportParameters[key] = $scope.user.username;
            break;
          case 'drop_DateRange':
            $scope.schedule.reportParameters[key] = $scope.schedule.dateRange.id;
            break;
          case 'UserTZ':
            $scope.schedule.reportParameters[key] = $scope.user.claims.data.timezone
              ? moment.tz(Date.now(), $scope.user.claims.data.timezone).format('z')
              : 'UTC';
            break;
          case 'UserUOM':
            $scope.schedule.reportParameters[key] = $scope.user.claims.data.unitOfMeasure;
            break;
          case 'TimeZoneId':
            $scope.schedule.reportParameters[key] = $scope.user.claims.data.timezone
              ? $scope.user.claims.data.timezone
              : 'UTC';
            break;
        }
      }
    }
    let data = {
      jobName: $scope.schedule.jobName,
      reportPath: $scope.schedule.reportPath, //$stateParams.folder + "/" + $stateParams.name,
      reportName: $scope.scheduleName, //$stateParams.name,
      startAt: $scope.schedule.startDate,
      recurrence: {
        frequency: $scope.schedule.recurrence,
        interval: 1,
      },
      contacts: $scope.schedule.contacts,
      reportParameters: $scope.schedule.reportParameters,
      tags: [$scope.tag],

      attrs: {
        scheme: 'reports',
        type: $scope.scheduleName ? $scope.scheduleName : '',
      },
      equipment: (function () {
        let arr = [];
        $scope.schedule.selectedAssets.forEach((asset) => {
          if (typeof asset === 'string') {
            arr.push({
              id: asset,
              name: asset,
            });
          } else {
            arr.push({
              id: asset.id,
              name: asset.name,
            });
          }
        });
        return arr;
      })(),
    };
    $scope.schedule.data = data;
    return $scope.schedule;
  };

  //If a scheduled csv export is being processed add the additional parameters needed
  //for the csv export to be performed. (datapoints and range)
  function addCSVParams() {
    var today = new Date(),
      offset,
      startDate,
      endDate,
      temp;
    temp = today.getDate();
    var datapoints = (function () {
      var arr = [];
      angular.forEach(Object.keys($rootScope.datapointsSelected), function (datapoint) {
        arr.push(datapoint);
      });
      return arr;
    })();
    datapoints = datapoints.join(',');
    $scope.schedule.reportParameters['datapoint'] = datapoints;
    endDate = today.toISOString();
    $scope.schedule.reportParameters['dt_EndDate'] = endDate;

    if ($scope.schedule.dateRange.label === '7d') {
      offset = 7;
    } else if ($scope.schedule.dateRange.label === '30d') {
      offset = 30;
    } else if ($scope.schedule.dateRange.label === '90d') {
      offset = 90;
    }

    if ($scope.schedule.dateRange.label === 'MTD') {
      startDate = today.setDate(1);
    } else {
      startDate = today.setDate(temp - offset);
    }

    temp = new Date(startDate);
    startDate = temp.toISOString();
    $scope.schedule.reportParameters['dt_StartDate'] = startDate;
  }

  //PUBLIC METHODS
  $scope.ok = function (update) {
    $scope.submitted = true;
    $scope.schedule.deliveryTime = $scope.schedule.deliveryTime;
    $scope.numSelectedAssets = $scope.schedule.selectedAssets.length;
    $scope.maxEmails = $scope.maxEmails ? $scope.maxEmails : $scope.schedule.contacts.length;
    
    if (!isValid($scope.schedule)) {
      return false;
    }

    const params = gatherDataNewReq($scope.schedule);
    
    dataLayer.push({
      event: gtmEvents.analyticsScheduleReport,
      data: params,
    });

    if (update) {
      JobSchedulerService.updateSchedule(params).then(
        function () {
          $uibModalInstance.close($scope.schedule);
          $scope.error = false;
        },
        function () {
          $uibModalInstance.dismiss('cancel');
          $scope.error = gettextCatalog.getString('Error creating job schedule for this report.');
        },
      );
    } else {
      JobSchedulerService.createSchedule(params).then(
        function (response) {
          $uibModalInstance.close($scope.schedule);
          $state.go('reports.jobscheduledetail', {
            id: response.data.id,
          });
          $scope.error = false;
        },
        function () {
          //In the case of an error...it should show an error message to the end user
          $scope.error = true;
          // $uibModalInstance.dismiss('cancel');
        },
      );
    }

    scheduleAttributes.selectedAssets = $scope.schedule.selectedAssets;
    scheduleAttributes.dateRange = $scope.schedule.dateRange;
    $scope.disableModalWindow = true;
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  const isValid = function (schedule) {
    let diff = $scope.schedule.startDate.getTime() - $scope.schedule.minDate.getTime();
    let minDifference = -60000;
    const validAssets = schedule.reportDoesNotRequireAssets
      ? true
      : schedule.selectedAssets.length > 0;
    if (
      schedule.jobName &&
      validAssets &&
      schedule.contacts.length > 0 &&
      schedule.contacts.length <= $scope.maxEmails &&
      schedule.dateRange &&
      schedule.startDate &&
      schedule.deliveryTime.dateTime &&
      diff > minDifference
    ) {
      return true;
    } else {
      return false;
    }
  };
}
